module.exports = __webpack_public_path__ + "media/images/dividend/ic_loading-0b0b3ba19d723d5cb4cfc82f9133e91f.svg";